export default __webpack_public_path__ + "static/media/Graphik-BoldItalic.13b9b876.otf";